export { default as ConsentManager } from './ConsentManager';
